import { URL } from 'app/api/constants';
import type { BackendEntities } from 'app/lib/betting/betting-entities/reducers/types/backendEntities';

import type { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

const buildPrematchFavoritesQuery = (data: string): string => `categories=${data}`;

export const getPrematchFavoritesContent = (
  config: ServiceConfig,
  payload: { data: string; signature: string },
) => {
  type AdapterProps = { response: BackendEntities };
  const url = `${URL.PREMATCH_FAVORITES}?${buildPrematchFavoritesQuery(payload.data)}`;
  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
